import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuItemConfirm,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamInvitationDTO } from "@shaarp/common";
import { ChevronDownIcon } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";
import { useToast, useToastError } from "../ui/use-toast";

export default function DataTableCellUserInvitationActions({
  invitation,
}: {
  invitation: TeamInvitationDTO;
}) {
  const toastError = useToastError();
  const { toast } = useToast();
  const api = useApi();
  const { t } = useTranslation();
  const [isResending, setIsResending] = useState(false);

  const remove = async () => {
    try {
      await api.delete(`/my/team/invitation/${invitation.id}`);
      window.location.reload();
    } catch {
      toastError();
    }
  };

  const resend = async () => {
    try {
      setIsResending(true);
      await api.post(`/my/team/invitation/${invitation.id}/resend`);
      toast({
        title: t(
          "components.dataTableUsersInvitations.actions.resendSuccess",
        ),
      });
    } catch {
      toastError();
    } finally {
      setIsResending(false);
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline">
            {t("components.dataTableUsersInvitations.actions.actions")}
            <ChevronDownIcon className="ml-2" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={resend} disabled={isResending}>
            {t(
              "components.dataTableUsersInvitations.actions.resendInvitation",
            )}
          </DropdownMenuItem>
          <DropdownMenuItemConfirm
            className="text-red-500"
            text={t(
              "components.dataTableUsersInvitations.actions.confirmDelete",
            )}
            onConfirm={() => remove()}
          >
            {t("components.dataTableUsersInvitations.actions.deleteInvitation")}
          </DropdownMenuItemConfirm>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
